import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, TrendingUpIcon, Volume2Icon, SmileIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const pillars = [{
    icon: Volume2Icon,
    title: 'Señales Neutras',
    description: 'Desactivas el ritual que tu perro ya asoció con abandono (llaves, zapatos, puerta, bolso).'
  }, {
    icon: SmileIcon,
    title: 'Retornos Aburridos',
    description: 'Tu regreso deja de ser un pico emocional que convierte la salida en tragedia.'
  }, {
    icon: TrendingUpIcon,
    title: 'Escalera de Ausencias',
    description: 'Subes por niveles con un criterio simple: 8 de 10 repeticiones en calma antes de aumentar.'
  }];
  const handleCTAClick = () => {
    const pricingSection = document.getElementById('pricing');
    pricingSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-116">
      <div className="max-w-6xl mx-auto" data-id="element-117">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-118">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-6" data-id="element-119">
            Presentando: <span className="text-[#C7E0E7]" data-id="element-120">CALMA EN CASA</span>
          </h2>
          <p className="text-xl text-[#5C5C5C] max-w-3xl mx-auto mb-4" data-id="element-121">
            Plan de 7 y 21 días para enseñar a tu perro a quedarse solo
          </p>
          <p className="text-lg text-[#5C5C5C] max-w-2xl mx-auto" data-id="element-122">
            Un PDF práctico (sin relleno) para que puedas bajar el drama de
            puertas/cierres, medir progreso en segundos → minutos, y evitar
            retrocesos por "hacerlo de golpe".
          </p>
        </motion.div>

        <motion.div className="mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-123">
          <h3 className="text-2xl md:text-3xl font-bold text-[#2C2C2C] mb-8 text-center" data-id="element-124">
            El método (Unique Mechanism)
          </h3>

          <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} data-id="element-125">
            {pillars.map((pillar, index) => {
            const Icon = pillar.icon;
            return <motion.div key={index} className="bg-[#FBF9F6] rounded-2xl p-8 text-center" variants={itemVariants} data-id="element-126">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-[#C7E0E7] rounded-full mb-6" data-id="element-127">
                    <Icon className="h-8 w-8 text-[#2C2C2C]" aria-hidden="true" data-id="element-128" />
                  </div>
                  <h4 className="text-xl font-bold text-[#2C2C2C] mb-4" data-id="element-129">
                    {pillar.title}
                  </h4>
                  <p className="text-[#5C5C5C] leading-relaxed" data-id="element-130">
                    {pillar.description}
                  </p>
                </motion.div>;
          })}
          </motion.div>
        </motion.div>

        <motion.div className="bg-[#C7E0E7]/10 rounded-2xl p-8 md:p-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-131">
          <p className="text-xl font-bold text-[#2C2C2C] mb-6" data-id="element-132">
            Eso es lo que hace que el progreso sea real, no suerte.
          </p>
          <CTAButton onClick={handleCTAClick} ariaLabel="Descargar Plan" data-id="element-133">
            Descargar Plan
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}